import { langType } from './../types'

const lang: langType = {
  skills: '技能',
  interest: '爱好',
  team: '团队',
  nickname: '昵称',
  giveAName: '给自己起个名字',
  signature: '个性签名',
  baseInfo: '基本信息',
  id: '工号',
  brithday: '生日',
  updateBaseInfo: '更新基本信息',
  add: '自定义',
  selectSkillAndInterst: '请选择您的技能和爱好',
  saveAndClose: '保存并关闭',
  adminTips: '请输入技能和爱好,以英文分号(;)分割并且不要输入回车',
  skillAdmin: '技能与爱好管理',
  needSkills: '请选择您的技能!'
}

export default lang
